/* eslint-disable */
export default {
    tour_home_home_title: "Home",
    tour_home_request_assessment_description: "Hiermee kun je direct starten met het uitnodigen van een deelnemer",
    tour_home_request_assessment_title: "Aanvragen assessment",
    tour_home_search_participant_description: "Start direct met het zoeken naar een deelnemer",
    tour_home_search_participant_title: "Deelnemer zoeken",
    tour_home_organisations_description: "Bepaalde instellingen aanmaken of wijzigen? Je doet het via de organisatieinstellingen",
    tour_home_organisations_title: "Organisatieinstellingen",
    tour_home_create_profile_description: "Nieuwe functie? Maak direct een profiel aan om de juiste deelnemer te selecteren",
    tour_home_create_profile_title: "Maak een profiel",
    tour_home_home_description: "Dit is waar je altijd start op ons platform. Je ziet hier de meest recent beschikbaar gekomen rapportages",
    tour_next: "Volgende",
    tour_previous: "Vorige",
    tour_done: "Klaar"
};
